export const AuthConstants = {

  authKey: 'isLoggedin',
  authValue: 'true',
  authorEmail: 'authorEmail',

  cookieKey: 'LoginEmail'
}



// WEBPACK FOOTER //
// ./src/app/shared/constants/src/auth.constants.ts